import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Webhooks14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_241)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.01529 13.7499C10.7362 13.7417 13.75 10.7228 13.75 6.99994C13.75 3.27202 10.7279 0.249939 7 0.249939C3.27208 0.249939 0.25 3.27202 0.25 6.99994C0.25 10.7228 3.2639 13.7418 6.98487 13.7499L7.00006 13.75L7.01529 13.7499ZM5.0125 2.13919C3.97722 2.56295 3.10742 3.30784 2.52696 4.25H4.4616C4.59178 3.45025 4.7729 2.74645 5.0125 2.13919ZM1.89971 5.75H4.29174C4.23686 6.56157 4.23686 7.43843 4.29174 8.25H1.89974C1.70404 7.44878 1.70402 6.55123 1.89971 5.75ZM2.52704 9.75C3.10749 10.6921 3.97723 11.4369 5.01245 11.8607C4.77287 11.2534 4.59177 10.5497 4.4616 9.75H2.52704ZM5.98376 9.75C6.10987 10.4386 6.27737 11.8761 7.00006 12.2448C7.72275 11.8761 7.89025 10.4386 8.01636 9.75H5.98376ZM9.53853 9.75C9.40836 10.5497 9.22726 11.2534 8.9877 11.8606C10.0228 11.4369 10.8925 10.692 11.473 9.75H9.53853ZM12.1003 8.25H9.70838C9.76326 7.43843 9.76326 6.56157 9.70838 5.75H12.1003C12.296 6.55123 12.296 7.44878 12.1003 8.25ZM8.20465 8.25H5.79548C5.73629 7.44964 5.73629 6.55036 5.79548 5.75H8.20465C8.26384 6.55036 8.26384 7.44964 8.20465 8.25ZM9.53853 4.25H11.473C10.8926 3.30788 10.0229 2.56301 8.98764 2.13925C9.22723 2.7465 9.40835 3.45028 9.53853 4.25ZM5.98376 4.25H8.01636C7.88997 3.55988 7.69269 2.10858 7.00006 1.75516C6.30744 2.10858 6.11015 3.55988 5.98376 4.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_241'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Webhooks14.displayName = 'Webhooks14';
export default Webhooks14;
